import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../assets/contexts/ThemeContext';
import MenuTree from './MenuTree';
import HeaderToolbar from '../../sites/default/layouts/HeaderToolbar';

/**
 * 우측 네비게이션 컴포넌트
 * 원본 navigation-right.html과 동일한 구조
 */
const NavigationRight = ({ menuData }) => {
  const themeContext = useTheme();
  const themeConfig = themeContext?.themeConfig || {};
  const headerLogo = themeConfig.headerLogo || { type: 'image', image: '/assets/images/logo/logo.png' };

  const renderLogo = () => {
    // 태그 타입인 경우
    if (headerLogo.type === 'tag' && headerLogo.tag) {
      const tag = headerLogo.tag;
      const logoStyle = tag.logo || {};

      return (
        <div className="header-logo-tag-container">
          <div
            className="header-logo-tag-circle"
            style={{
              width: `${logoStyle.size || 49}px`,
              height: `${logoStyle.size || 49}px`,
              background: logoStyle.backgroundColor || 'linear-gradient(135deg, #9333ea 0%, #3b82f6 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <span
              className="header-logo-tag-letter"
              style={{
                fontSize: logoStyle.fontSize || '1.5rem',
                fontWeight: 'bold',
                color: logoStyle.color || '#ffffff'
              }}
            >
              {logoStyle.letter || 'G'}
            </span>
          </div>
          <div className="header-logo-tag-text-container">
            {tag.title && (
              <h3
                className="header-logo-tag-title"
                style={{
                  color: tag.titleColor || '#ffffff',
                  fontSize: tag.titleStyle?.fontSize || '20px',
                  fontWeight: tag.titleStyle?.fontWeight || 700,
                  lineHeight: tag.titleStyle?.lineHeight || 1.2,
                  letterSpacing: tag.titleStyle?.letterSpacing || '0',
                  textTransform: tag.titleStyle?.textTransform || 'none',
                  margin: 0,
                  marginBottom: tag.subtitle ? '4px' : 0
                }}
              >
                {tag.title}
              </h3>
            )}
            {tag.subtitle && (
              <p
                className="header-logo-tag-subtitle"
                style={{
                  color: tag.subtitleColor || '#999999',
                  fontSize: tag.subtitleStyle?.fontSize || '14px',
                  fontWeight: tag.subtitleStyle?.fontWeight || 400,
                  lineHeight: tag.subtitleStyle?.lineHeight || 1.5,
                  letterSpacing: tag.subtitleStyle?.letterSpacing || '0',
                  textTransform: tag.subtitleStyle?.textTransform || 'none',
                  margin: 0
                }}
              >
                {tag.subtitle}
              </p>
            )}
          </div>
        </div>
      );
    }

    // 이미지 타입인 경우 (기본)
    return (
      <img
        src={headerLogo.image || '/assets/images/logo/logo.png'}
        alt="logo"
      />
    );
  };

  return (
    <aside className="nav-layout nav-layout-right" id="nav-layout-right" aria-label="Right Navigation">
      <div className="nav-layout__inner">
        <div className="nav-layout__logo">
          <Link to="/">
            {renderLogo()}
          </Link>
        </div>
        <div className="nav-layout__menu">
          <nav>
            {menuData && menuData.length > 0 ? (
              <MenuTree items={menuData} level={0} />
            ) : null}
          </nav>
        </div>
        <HeaderToolbar variant="nav" />
      </div>
    </aside>
  );
};

export default NavigationRight;

